import { render, staticRenderFns } from "./AdminDocumentosAsignar.vue?vue&type=template&id=d11ed6a0&"
import script from "./AdminDocumentosAsignar.vue?vue&type=script&lang=ts&"
export * from "./AdminDocumentosAsignar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports